module.exports = __webpack_public_path__ + "static/media/HKGrotesk-ExtraBold.2d69b435.ttf";